import { OctNumberField } from '@oceantech/oceantech-ui';
import clsx from 'clsx';
import { useState } from 'react';
import EditableCell from '../../../../phan-he-kham-benh/modals/modal-chi-dinh-dich-vu/cells/EditableCell';
import { PaymentCellEditProps } from './types';

const SvcTotalPaymentCell = ({
	rowData,
	onCellEdit,
	rowIndex,
	cellIndex,
	editable,
	selectedCell,
	setSelectedCell,
}: PaymentCellEditProps) => {
	const [inputValue, setInputValue] = useState(rowData?.svcTotalPercent);
	const [errorMessage, setErrorMessage] = useState('');

	const CELL_ID = `${rowData.id}${cellIndex}`;

	return (
		<EditableCell
			disabled={!editable}
			className={clsx({
				'focus-cell': CELL_ID === selectedCell,
				'min-h-28': rowData?.id,
			})}
			textValue={rowData?.svcTotalPercent}
			textClassName={clsx('text-center fw-normal spaces line-height-28', {
				'text-danger': rowData?.isCancel,
			})}
			editComponent={({ setEnableEditing }: any) => {
				return (
					<OctNumberField
						className="w-100 editable-cell"
						inputClassName="w-100 text-end"
						name="svcTotalPercent"
						maxLength={3}
						autoFocus
						allowNegative={false}
						value={inputValue}
						onChange={(value) => {
							setInputValue(value);
							setErrorMessage(
								value > 100 ? 'Giá trị nhập không vượt quá 100%' : ''
							);
						}}
						touched
						error={errorMessage}
						onBlur={() => {
							setSelectedCell(CELL_ID);

							if (errorMessage) return;

							if (inputValue !== rowData?.svcTotalPercent) {
								onCellEdit(
									rowData,
									inputValue,
									rowIndex,
									'svcTotalPercent',
									rowData.svcTotalPercent
								);
							}
							setEnableEditing(false);
						}}
					/>
				);
			}}
		/>
	);
};

export default SvcTotalPaymentCell;
